import { render, staticRenderFns } from "./CreateProductionZoneModal.vue?vue&type=template&id=c0a514c0&scoped=true&"
import script from "./CreateProductionZoneModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductionZoneModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductionZoneModal.vue?vue&type=style&index=0&id=c0a514c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a514c0",
  null
  
)

export default component.exports